import { useState, useEffect } from "react";
import ContentIcon from "@/shared/ContentIcon";
import { CFoodCard, StarList } from "./styles";
import SaveCollectionsNews from "../SaveCollectionsNews";
import { minutesToHoursAndMinutes } from "@/helpers/formatDate";
import { getUserProfile } from "helpers";
import { useAuth0 } from "@auth0/auth0-react";
import { useContext } from "react";
import TemplateContext from "@/context/Template/TemplateContext";
import { ReviewStars } from "@/shared/ToolBarRecipes/ReviewStars";
import { useAppTrue } from "@/hooks/index";

const FoodRanking = ({
  elementID,
  rating = 3,
  tags,
  features,
  noteDetail,
  isBorderNone,
  isColumnLayout,
  classCustom = "",
}) => {
  const dataContext = useContext(TemplateContext);
  const { content } = dataContext;
  const { recipesReview } = content;
  const sectionWithUnderscore = "_7_";
  const noteIdWithSection = sectionWithUnderscore+elementID;
  const dataReview = recipesReview?.find((review) => review.externalSubjectId == noteIdWithSection);
  const isApp = useAppTrue();

  const [authData, setAuthData] = useState(null);
  const { _id } = noteDetail;
  const { getAccessTokenSilently } = useAuth0();

  let recipeTime = parseInt(features?.preparationTime || 0) + parseInt(features?.cookingTime || 0);

  const indexSlugFeatured = tags?.findIndex((tag) => ["recetas-faciles","recetas-rapidas","comida-saludable"].includes(tag?.slug) && tag?.name);
  const replaceNameTag = {
    "recetas-faciles": "Fácil",
    "recetas-rapidas": "Rápida",
    "comida-saludable": "Saludable",
  }

  return (
    <CFoodCard
      className={`${isBorderNone ? "borderNone" : ""} ${classCustom} ${
        isColumnLayout ? "foodCardColumn" : ""
      } ${"food-card"}`} // se aplican para quitar la line punteada o para hacer direccion columns
    >
      <ReviewStars dataReview={dataReview}/>

      {/* <div id="comentarios" data-size="2"></div> */}
      <div className="food-card__info">
        {indexSlugFeatured > -1 && <div className="food-card__badge"><span>{replaceNameTag[tags[indexSlugFeatured].slug]}</span></div>}
        <div className="food-card__options">
          <div className="food-card__time">
            {minutesToHoursAndMinutes(recipeTime)}
          </div>
          {!isApp &&
            <SaveCollectionsNews list={true} noteDetail={noteDetail} classCustom="food-card__btnSaveCollection"/>
          }
        </div>
      </div>
    </CFoodCard>
  );
};

export default FoodRanking;
